<template>
  <div class="content">

      <div class="container-fluid mt-4">

          <stats-card title="Trap details" type="default" :sub-title="data.barcode" :isBiosecurity="data.isBiosecurity" icon="fas fa-map-marker-alt">

            <template slot="append">

              <div style="position: absolute; z-index: 1000; right: 1rem; top: 1rem">

                <div style="display: inline-block" v-if="sensorSuggestedOrgs.length > 0">
                  <el-select v-model="sensorOwnerOrg.organisationId" placeholder="Suggested orgs">
                    <template slot="prefix"><i class="fas fa fa-sitemap" style="margin: 15px 0 0 3px"></i></template>
                    <el-option v-for="org in sensorSuggestedOrgs" :key="org.id" :value="org.id" :label="org.name"></el-option>
                  </el-select>
                  <el-select v-model="selectedPestType" placeholder="Pest type" style="margin-left: 0.5rem">
                    <el-option v-for="pest in pestTypes" :key="pest.id" :value="pest.id" :label="pest.name"></el-option>
                  </el-select>
                  <el-button @click="sensorSuggestedOrgs = []; showSensorNewOrgModal = true" style="margin-left: 0.5rem">
                    or pick an Org
                  </el-button>
                </div>


                  <span v-if="sensorOwnerOrg.name">{{sensorOwnerOrg.name}}</span>

                <!-- TODO add disabledDate -->
                  <el-date-picker
                    v-model="sensorOwnerOrg.createdOn"
                    v-if="sensorOwnerOrg.organisationId && selectedPestType"
                    value-format="timestamp"
                    format="dd/MM/yyyy"
                    type="date"
                    placeholder="Owned since..." style="margin-left: 1rem">
                  </el-date-picker>

                  <el-button v-if="sensorOwnerOrg.createdOn" @click="linkSensorOrg" style="background:#58CC95; color: #FFF; margin: 0 1rem">
                    <i class="fas fa fa-link"></i> Link Org
                  </el-button>

                <div style="display: inline-block" v-if="sensorCurrentOrg.organisation && sensorCurrentOrg.organisation.name">
                  <el-button @click="showSensorCurrentOrgModal = true">
                    <i class="fas fa fa-sitemap"></i> <strong>{{sensorCurrentOrg.organisation.name}}</strong> (since {{timeHelper.formatDate(sensorCurrentOrg.createdOn)}})
                  </el-button>
                </div>

                <div v-else-if="sensorSuggestedOrgs.length == 0 && sensorOwnerOrg.organisationId == null" style="display: inline-block">
                  <el-button @click="showSensorNewOrgModal = true">
                    No current owner Org
                  </el-button>
                </div>

                <el-divider direction="vertical"></el-divider>

                <el-dropdown @command="handleStatusChange">
                  <el-button :class="`text-${data.currentStatus.colour}`">
                    <i :class="`text-${data.currentStatus.colour} fas fa fa-${data.currentStatus.icon}`"></i> {{data.currentStatus.description}}
                  </el-button>
                  <el-dropdown-menu slot="dropdown">

                    <el-dropdown-item :disabled="true">
                      Switch status to...
                    </el-dropdown-item>

                    <el-dropdown-item :divided="name == 0" v-for="(value, name) in data.currentStatus.availableStatuses" :command="name" :key="name">
                      <i :class="`text-${sensorStatusHelper.getColour(parseInt(name),null)} fas fa fa-${sensorStatusHelper.getIcon(parseInt(name),null)}`"></i> {{value}}
                    </el-dropdown-item>

                    <el-dropdown-item command="history" :divided="true">
                      View history
                    </el-dropdown-item>


                  </el-dropdown-menu>
                </el-dropdown>

              </div>

              <base-alert v-if="data.statuses.length == 0">
                Suggested status: {{getSuggestedStatus()}}
              </base-alert>

              <b-card no-bod class="tab-wrapper">
                <b-card-header header-tag="nav">
                    <b-nav card-header tabs>
                        <b-nav-item @click="setActiveTab(1)"  :active="activeTab == 1"><i class="fas fa-heartbeat"></i> Trap Vitals</b-nav-item>
                        <!-- <b-nav-item @click="setActiveTab(2)"  :active="activeTab == 2">
                          Detections
                          <span :class="`ml-1 badge badge-warning`">2</span>
                        </b-nav-item> -->
                        <b-nav-item @click="setActiveTab(3)" :active="activeTab == 3"><i class="fas fa-tree"></i> Parent Orchard(s)</b-nav-item>
                        <b-nav-item @click="setActiveTab(4)" :active="activeTab == 2"><i class="fas fa-map-marker-alt"></i> Trap Details</b-nav-item>
                    </b-nav>
                </b-card-header>

                <!-- PARENT ORCHARDS -->
                <div class="tab-container" v-if="activeTab == 3">

                  <div v-if="data.orchards.length > 0">

                    <base-alert>This is a read-only table. Adding / removing a trap to /from an orchard is done from the orchard page itself.</base-alert>

                    <entity-picker
                        apiEndpoint="getGroups"
                        :canSearch="false"
                        :canSelect="false"
                        :canRefresh="false"
                        :selected="data.orchards"
                        rootProp="sensorOrchards"
                        :tableColumns="sensorTableColumns"
                        :canEdit="true"
                        editPath="/groups/"
                    >
                    </entity-picker>

                  </div>

                  <base-alert v-else>No orchards associated to this trap. Head to any orchard to link it to this trap.</base-alert>

                </div>

                <!-- DETECTIONS -->
                <div class="tab-container" v-if="activeTab == 2">

                  <!-- <base-alert type="warning" :action="{
                    label: 'Details'
                  }">
                    Many night-time detections have recently occured
                  </base-alert>

                  <base-alert type="warning" :action="{
                    label: 'Details'
                  }">
                    This trap recently had many weak detections vs few strong ones
                  </base-alert>

                <div>
                  <b-card >
                    <span class="mr-3">Fetch detection data:</span>
                    <el-date-picker
                        v-model="value1"
                        type="daterange"
                        format="dd/MM/yyyy"
                        range-separator="To"
                        start-placeholder="Start date"
                        end-placeholder="End date"
                        :picker-options="pickerOptions"
                        @change="onDatePick"
                        >
                      </el-date-picker>

                      <div v-if="detections.length > 0" class="mt-4">
                        <entity-picker
                          :canEdit="true"
                          :canSelect="false"
                          :canSearch="false"
                          :canExport="true"
                          placeHolder="Search for detections"
                          apiEndpoint="getSensorDetections"
                          :selected="detections"
                          :filters="tableFilters"
                          :tableOptions="detectionTableOptions"
                          editPath="/sensors/"
                          :tableColumns= tableColumns
                        >
                        </entity-picker>
                      </div>
                  </b-card>
                </div> -->

                </div>

                <!-- VITALS -->
                <div class="tab-container" v-if="activeTab == 1">
                  <div class="row">
                    <div class="col">
                      <stats-card title="Battery" :type="getTypeFromValue('battery')" :sub-title="`${data.batteryLevel}`" :icon="`fas fa fa-${getBatteryIconFromValue()}`"></stats-card>
                    </div>
                    <div class="col">
                      <stats-card title="Last packet received" :type="getLastPingType()" :sub-title="getLastActivityText()" icon="fas fa fa-signal"></stats-card>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <stats-card title="Pest Type" type="default" :sub-title="`${data.pestType.name || 'N/A'}`" :icon="`fas fa fa-crosshairs`"></stats-card>
                    </div>
                    <div class="col">
                      <stats-card title="Trap Location" type="default" :sub-title="`${locationText}`" :icon="`fas fa fa-crosshairs`" :copyToClipboard="!!locationText"></stats-card>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <stats-card title="GPS" :type="!data.hasLocation ? 'warning' : 'success'" :sub-title="!data.hasLocation ? 'No location' : (data.forcedLocation ? 'Manual' : 'Ok')" icon="fas fa fa-map-marker">
                        <!-- <template slot="actions">
                            <a class="dropdown-item" href="javascript:void(0)" @click="showCreateModal = true">Browse GPS fix log</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="showLocationModal = true">Set manual location</a>
                        </template> -->
                        <template slot="append">
                          <set-location v-if="data.hasLocation" key="locationLookup" :showInput="false" :location="data.location" @onLocationSet="setLocation" :showMap="true"></set-location>
                        </template>
                      </stats-card>
                    </div>
                    <!-- <div class="col">
                      <stats-card title="Firmware version" type="warning" sub-title="1.23.328928" icon="fas fa fa-microchip">
                        <template slot="actions">
                            <a class="dropdown-item" href="javascript:void(0)" @click="showCreateModal = true">Install new firmware</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="showCreateModal = true">Browse history log</a>
                        </template>
                      </stats-card>
                    </div> -->
                  </div>
                </div>

                <!-- DETAILS -->
                <div class="mt-3" v-if="activeTab == 4">
                  <base-alert>
                      This sensor was created on {{data.dateCreated}}
                  </base-alert>

                  <form-sensor :data="updatedSensorData"></form-sensor>

                  <div class="mt-3" align="right">
                      <base-button type="primary" @click="updateSensor">
                          Update details
                      </base-button>
                  </div>
                  </div>
              </b-card>
            </template>

          </stats-card>

      </div>

      <modal :show.sync="showSwitchStatusModal">
          <h6 slot="header" class="modal-title">Switch sensor status</h6>

          <b-row class="switchStatusRow" justify="center" align="middle" type="flex">

            <el-col :span="10">
              <i :class="`text-${data.currentStatus.colour} fa-3x fas fa fa-${data.currentStatus.icon}`"></i>
              <h4>{{data.currentStatus.description}}</h4>
            </el-col>

            <el-col :span="4">
              <i class="text-primary fas fa fa-angle-double-right fa-3x"></i>
            </el-col>

            <el-col :span="10">
              <i :class="`text-${sensorStatusHelper.getColour(newSensorStatus.status,newSensorStatus.subStatus)} fas fa-3x fa fa-${sensorStatusHelper.getIcon(newSensorStatus.status,newSensorStatus.subStatus)}`"></i> {{value}}
              <h4>{{newSensorStatus.description}}</h4>
            </el-col>

          </b-row>

          <el-select v-model="newSensorStatus.subStatus" placeholder="Pick a sub-status" v-if="newSensorStatus.subStatuses" style="display: block;margin-bottom: 1rem;">
            <el-option v-for="(value, name)  in newSensorStatus.subStatuses" :key="name" :value="name" :label="value"></el-option>
          </el-select>

          <base-alert v-if="newSensorStatus.status == 2">
            GPS location will be wiped from DB
          </base-alert>

          <base-alert>
            Pick a custom status date (defaults to now if left empty)
          </base-alert>

          <el-date-picker style="display:block; margin: 0 0 1rem 0"
            v-model="newSensorStatus.createdOn"
            value-format="timestamp"
            format="dd/MM/yyyy"
            type="date"
            placeholder="Set status date to...">
          </el-date-picker>

          <el-input type="textarea" placeholder="Optional note" v-model="newSensorStatus.note"></el-input>

          <template slot="footer">
              <base-button type="blank" @click="showSwitchStatusModal = false">Cancel</base-button>
              <base-button type="primary" :disabled="!newSensorStatus.doesValidate() || (newSensorStatus.subStatus && newSensorStatus.subStatus == data.currentStatus.subStatus)" @click="switchSensorStatus">Confirm</base-button>
          </template>
      </modal>

      <modal :show.sync="showLocationModal">
          <h6 slot="header" class="modal-title">Set manual location</h6>

          <base-alert>
            This location will be set for all parent orchards
          </base-alert>

          <set-location @onLocationSet="setLocation" :location="data.location != '' ? data.location : null">
          </set-location>

          <template slot="footer">
              <base-button type="blank" @click="showLocationModal = false">Cancel</base-button>
              <base-button type="primary" @click="updateSensor">Set location</base-button>
          </template>
      </modal>

      <!-- HISTORY MODAL -->
      <modal :show.sync="showStatusHistory">

        <h6 slot="header" class="modal-title">Sensor history</h6>

        <el-timeline>

          <el-timeline-item :timestamp="getStatusTimeRange(status)" placement="top" v-for="status in data.statuses" :key="status.createdOn">
            <el-card shadow="never" class="statusHistoryCard">
              <h4>
                <i :class="`text-${sensorStatusHelper.getColour(status.status,status.subStatus)} fas fa fa-${sensorStatusHelper.getIcon(status.status,status.subStatus)}`"></i> <strong :class="`text-${sensorStatusHelper.getColour(status.status,status.subStatus)}`">{{status.description}}</strong>
              </h4>
              <div v-if="status.user != null">{{status.user.name}}</div>
              <div v-else>System log</div>

              <p v-if="status.note != ''"><em>{{status.note}}</em></p>
            </el-card>
          </el-timeline-item>

        </el-timeline>

        <template slot="footer">
            <base-button type="blank" @click="showStatusHistory = false">Close</base-button>
        </template>

      </modal>
      <!-- END HISTORY MODAL -->

      <!-- REMOVE SENSOR ORG MODAL -->
      <modal :show.sync="showSensorCurrentOrgModal">
          <h6 slot="header" class="modal-title">Current Org</h6>

          <el-timeline>

            <el-timeline-item :timestamp="getOrgTimeRange(org)" placement="top" v-for="org in sensorOrgs" :key="org.createdOn">
              <el-card shadow="never" class="statusHistoryCard">
                <h4>
                  {{org.organisation.name}}
                </h4>
              </el-card>
            </el-timeline-item>

          </el-timeline>

          <el-divider>REMOVE ORG</el-divider>

          <base-alert type="warning">
            Removing this org will also dissociate this trap from any orchard it's currently deployed on.
          </base-alert>

          <el-date-picker
            v-model="sensorCurrentOrg.completedOn"
            value-format="timestamp"
            format="dd/MM/yyyy"
            type="date"
            placeholder="Set removed date to..." style="margin-left: 1rem">
          </el-date-picker>

          <template slot="footer">
              <base-button type="danger" @click="removeSensorCurrentOrg" v-if="sensorCurrentOrg.completedOn != null">Remove Org</base-button>
              <base-button type="blank" @click="showSensorCurrentOrgModal = false">Close</base-button>
          </template>
      </modal>
      <!-- END REMOVE SENSOR ORG MODAL -->

      <!-- ADD SENSOR ORG MODAL -->
      <modal :show.sync="showSensorNewOrgModal">
          <h6 slot="header" class="modal-title">Select Pest Type and Org</h6>
          <base-input label="Pest type selector">
            <select class="form-control" v-model="selectedPestType">
              <option
                v-for="(item, index) in pestTypes"
                :value="item.id"
                :key="index">{{item.name}}</option>
            </select>
            <p v-if="selectedPestType === null" class="text-red">Pest type is required.</p>
          </base-input>
          <h4>Add Sensor Organisation</h4>
            <entity-picker
              key="sensorOrgPick"
              apiEndpoint="getOrgs"
              :canSearch="true"
              :canSelect="true"
              :canRefresh="false"
              :multiple="false"
              rootProp="organisations"
              :canEdit="true"
              editPath="/orgs/"
              @onSelect="onSensorOrgPick"
            >
            </entity-picker>

            <!-- <template slot="footer">
                <base-button type="blank" @click="showSensorNewOrgModal = false">Cancel</base-button>
                <base-button type="danger">Remove Org</base-button>
            </template> -->
      </modal>
      <!-- END ADD SENSOR ORG MODAL -->




  </div>
</template>

<script>
import { StatusMap, SubStatusMap } from '@/config/SensorStatuses';
import { SensorStatusHelper } from '@/helpers/SensorStatusHelper';
import { sensorHealth } from '@/config/SensorHealth'
import {
  DatePicker,
  Dropdown,
  Button,
  DropdownItem,
  DropdownMenu,
  Row,
  Col,
  FormItem,
  Input,
  Timeline,
  TimelineItem,
  Card,
  Select,
  Option,
  Divider
  } from 'element-ui';
import moment from 'moment';
import { TimeHelper } from '@/helpers/TimeHelper';
import api from '@/api'
import { tableColumns, tableFilters, detectionTableOptions } from '@/config/DetectionTable'
import { sensorTableColumns } from '@/config/GroupTable'
import { datePickerReadyDates } from '@/config/Time'
import { OrganisationModel } from '@/models/organisation/organisation'
import { SensorModel } from '@/models/sensor/sensor'
import { SensorStatusModel } from '@/models/sensor/sensorStatus'
import BaseAlert from '../components/BaseAlert.vue';
export default {
  components: {
    BaseAlert,
    [DatePicker.name]: DatePicker,
    [Dropdown.name]: Dropdown,
    [Button.name]: Button,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Row.name]: Row,
    [Select.name]: Select,
    [Option.name]: Option,
    [Col.name]: Col,
    [FormItem.name]: FormItem,
    [Input.name]: Input,
    [Timeline.name]: Timeline,
    [TimelineItem.name]: TimelineItem,
    [Card.name]: Card,
    [Divider.name]: Divider,
  },
  data() {
    return {
      newSensorStatus: new SensorStatusModel(),
      sensorStatusHelper: SensorStatusHelper,
      statusMap: StatusMap,
      data: null,
      activeTab: 1,
      sensorGroups: [],
      sensormap: null,
      showLocationModal: false,
      showSwitchStatusModal: false,
      showStatusHistory: false,
      showSensorCurrentOrgModal: false,
      showSensorNewOrgModal: false,
      updatedSensorData: null,
      value1: '', // TODO rename
      detections: [],
      tableFilters: tableFilters,
      tableColumns: tableColumns,
      pickerOptions: datePickerReadyDates,
      tableOptions: detectionTableOptions,
      timeHelper: TimeHelper,
      sensorSuggestedOrgs: [],
      sensorOrgs: [],
      sensorCurrentOrg: {

      },
      pestTypeName: null,
      pestTypes: [],
      selectedPestType: null,
      sensorOwnerOrg: {
        organisationId: null,
        createdOn: null
      },
      sensorTableColumns: sensorTableColumns,
      locationText: ''
    };
  },
  created: async function() {
    this.fetchSensor();
    this.getPestTypes();
  },
  methods: {
    getSuggestedStatus() {
      let output = '';
      let battery = this.data.hasStatus ? this.data.lastStatus.battery : 0;
      let isLowBattery = battery < 5
      let days = this.getDaysSinceLastPing();
      let isNoSignal = days > 2
      let isDeployed = this.data.orchards.length > 0
      let hasNoLocation = !this.data.hasLocation
      if(isDeployed) {
        if(isNoSignal) {
          output = 'Disconnected'
          if(isLowBattery) {
            output = `${output} (out of battery)`
          }
          else output = `${output} (unknown)`
        }
        else {
          if(hasNoLocation) output = 'Fault (GPS)'
          else output = 'Operational'
        }
      }
      // not currently deployed
      else {
        if(isLowBattery) output = ' ? (no battery)'
        if(hasNoLocation) output = ' ? (no GPS)'
        else output = 'Ready for deployment'
      }
      return output
    },
    onSensorOrgPick(selected) {
      if (this.selectedPestType !== null) {
        this.addSensorError = false;
        this.showSensorNewOrgModal = false
        this.sensorOwnerOrg = {
          name: selected[0].name,
          organisationId: selected[0].id,
          createdOn: null
        }
      }
    },
    getStatusTimeRange(status) {
      if(status.completedOn == null) {
        return `Since ${status.dateCreated}`
      }
      return `${status.dateCreated} - ${status.dateCompleted}`
    },
    getOrgTimeRange(status) {
      if(status.completedOn == null) {
        return `Since ${this.timeHelper.formatDate(status.createdOn)}`
      }
      return `${this.timeHelper.formatDate(status.createdOn)} - ${this.timeHelper.formatDate(status.completedOn)}`
    },
    linkSensorOrg: async function() {
      this.$emit('loading', true);
      const results = await api.linkSensorOrganisation(this.$route.params.id, {
        organisationId: this.sensorOwnerOrg.organisationId,
        createdOn: TimeHelper.toSeconds(this.sensorOwnerOrg.createdOn),
        pestTypeId: this.selectedPestType
      })
      this.sensorOwnerOrg = {}
      this.sensorSuggestedOrgs = []
      this.fetchSensor()
    },
    removeSensorCurrentOrg: async function() {
      this.showSensorCurrentOrgModal = false
      this.$emit('loading', true);
      const results = await api.removeSensorOrganisation(this.$route.params.id, {
        removedOn: TimeHelper.toSeconds(this.sensorCurrentOrg.completedOn),
        status: this.data.currentStatus.status,
        subStatus: this.data.currentStatus.subStatus
      })
      this.sensorCurrentOrg = {}
      this.fetchSensor()
    },
    fetchSuggestedOrgs: async function() {
      this.$emit('loading', true);
      const results = await api.getSensorSuggestedOrganisations(this.$route.params.id)

      for(let org of results[0]['organisations']) {
        let isAlreadyThere = this.sensorSuggestedOrgs.filter((o) => o.id == org.id).length > 0
        if(!isAlreadyThere) this.sensorSuggestedOrgs.push(new OrganisationModel(org))
      }
      this.$emit('loading', false);
    },
    fetchOrgs: async function() {
      this.$emit('loading', true);
      const results = await api.getSensorOrganisations(this.$route.params.id)
      let orgs = results[0]['organisations']
      if(orgs.length == 0) {
        this.fetchSuggestedOrgs()
      }
      else {
        this.sensorOrgs = orgs.sort((a,b) => a.createdOn < b.createdOn ? 1 : -1)
        this.sensorCurrentOrg = orgs.filter((o) => o.completedOn == null)[0] || {}
      }

      this.$emit('loading', false);
    },
    fetchSensor: async function() {
      this.$emit('loading', true);
      const results = await api.getSensor(this.$route.params.id)
      this.data = new SensorModel(results);
      this.updatedSensorData = new SensorModel(results)
      this.fetchOrgs()
      this.data.statuses.sort((a,b) => a.createdOn < b.createdOn ? 1 : -1);
      this.pestTypeName = this.data.pestType && this.data.pestType.name;
      this.getLocationText();
    },
    handleStatusChange(newStatus) {
      if(newStatus == 'history') {
        this.showStatusHistory = true
        return
      }
      this.newSensorStatus = new SensorStatusModel(),
      this.newSensorStatus.status = parseInt(newStatus)
      this.showSwitchStatusModal = true
    },
    switchSensorStatus: async function() {
      this.showSwitchStatusModal = false
      this.$emit('loading', true);
      let user = JSON.parse(localStorage.getItem('profile'))
      this.newSensorStatus.user = {
        id: user.id
      }
      await api.createSensorStatus(this.$route.params.id,this.newSensorStatus.exportToCreate())
      this.fetchSensor();
    },
    setLocation(latlng) {
      this.location = latlng
    },
    onDatePick: async function(date) {
      this.$emit('loading', true);
      const detectionResults = await api.getSensorDetections() // TODO include daterange param
      this.$emit('loading', false);
      this.detections = detectionResults
    },
    getBatteryIconFromValue: function() {
      let battery = this.data.hasStatus ? this.data.lastStatus.battery : 0;
      switch(true) {
        case battery > 90:
          return 'battery-full';
        case battery > 65:
          return 'battery-three-quarters';
        case battery > 40:
          return 'battery-half';
        case battery > 20:
          return 'battery-quarter';
        default:
          return 'battery-empty';
      }
    },
    getTypeFromValue: function(type) {
      switch(type) {
        case 'battery':
          let battery = this.data.hasStatus ? this.data.lastStatus.battery : 0;
          switch(true) {
            case battery > 50:
              return 'success';
            case battery > 20:
              return 'warning';
            default:
              return 'danger';
          }
      }
    },
    getLastPingType() {
      let days = this.getDaysSinceLastPing();
      if (days === null) return 'danger'
      switch(true) {
        case days > 2:
            return 'danger'
        case days >= 1:
            return 'warning'
        default:
            return 'success'
      }
    },
    getLastActivityText() {
      return this.data.latestSensorActivityDate ? `${this.getDaysSinceLastPing()} days ago (${this.data.lastReported})` : 'N/A';
    },
    getLocationText() {
      if (this.data && this.data.location && this.data.location.lat && this.data.location.lon) {
        this.locationText = `${this.data.location.lat} ${this.data.location.lon}`;
      }
    },

    getDaysSinceLastPing() { // TODO getter from model
      if (!this.data.latestSensorActivityDate) return null
      const ping = moment(this.data.latestSensorActivityDate)

      return moment(moment.now()).diff(ping,'days')
    },

    updateSensor: async function() {
      this.showLocationModal = false
        if(this.location) {
            this.data.forcedLocation = true
            this.data.location = this.location
        }

        this.$emit('loading', true);
        const results = await api.updateSensor(this.data.id,this.updatedSensorData.toDetailsUpdateJson(this.data))
        this.$emit('loading', false);
        this.$emit('onApiResult', "Trap has been updated");
    },
    setActiveTab: async function(tab) {
        this.activeTab = tab

        switch(tab) {
          case 0:
            if(this.sensorGroups.length == 0) {
              this.$emit('loading', true);
              const groupResults = await api.getGroups({
                'sensors.id': this.data.id
              })
              this.sensorGroups = groupResults
              this.$emit('loading', false);
            }
            break;
        }

    },
    getPestTypes() {
      api.getPestTypes().then((response) => {
        this.pestTypes = response.records
      })
    },
  }
};
</script>

<style lang="scss" scoped>
  .switchStatusRow {
    text-align: center;
    margin: 3rem 0;

    i {
      margin-bottom: 1rem;
    }
  }

  .statusHistoryCard {
    background: #FAFAFA;
    color: #888;

    h4 {
      text-transform: uppercase;
    }

    p {
      background: white;
      border-radius: 5px;
      border: 1px #DDD solid;
      font-size: 0.9rem;
      margin-top: 1rem;
      color: #111;
      padding: 0.5rem;
    }
  }
</style>
